import React, { useState } from 'react';
import { Pencil, Trash, Plus, Search, Mail, Phone } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';

const ProjectHeadMaster = () => {
  const { projectHeads, projects, addProjectHead, updateProjectHead, deleteProjectHead } = useAdmin();

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingHead, setEditingHead] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    projectId: '',
  });

  const handleSubmit1 = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile || !formData.email || !formData.projectId) {
      alert.error('Please fill all required fields');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    if (editingHead) {
      updateProjectHead(editingHead.id, formData);
      alert('Project Head updated successfully');
    } else {
      addProjectHead(formData);
      alert('Project Head created successfully');
    }

    resetForm();
  };


  const handleSubmit2 = async (e) => {
    e.preventDefault();

    const payload = {
      full_name: formData.name,
      mobile_number: formData.mobile,
      email: formData.email,
      project_id: formData.projectId,
      project_name: getProjectName(formData.projectId),
    };
    console.log('this is payload', payload)
    if (editingHead) {
      await updateProjectHead(editingHead.user_id, payload);
      alert("Project Head updated");
    } else {
      await addProjectHead(payload);
      alert("Project Head created");
    }

    resetForm();
  };

  // const getProjectName = (projectId) => {
  //    console.log('this is projectId', projectId)
  //   console.log('this is projects', projects)

  //   const project = projects.find(
  //     (item) => item.id === projectId
  //   );
  //   return project ? project.title : "";
  // };

  const getProjectName = (projectId) => {
    const id = Number(projectId); // 👈 CRITICAL
    const project = projects.find(p => p.id === id);
    return project ? project.title : "Not Assign ";
  };



  const handleSubmit = async (e) => {

    const projectName =
      projects.find(p => p.id === formData.projectId)?.title || "";

    e.preventDefault();

    const formDataObj = new FormData();

    formDataObj.append("full_name", formData.name);
    formDataObj.append("email", formData.email);
    formDataObj.append("mobile_number", formData.mobile);
    // formDataObj.append("project_id", formData.projectId);
    formDataObj.append("project_id", Number(formData.projectId));
    formDataObj.append("project_name", getProjectName(formData.projectId));

    // only if you have file input
    if (formData.profile_photo) {
      formDataObj.append("profile_photo", formData.profile_photo);
    }

    console.log("FormData entries:");
    for (let pair of formDataObj.entries()) {
      console.log(pair[0], pair[1]);
    }

    // await addProjectHead(formDataObj);
    // alert("Project Head created");

    // resetForm();
      if (editingHead) {
    await updateProjectHead(editingHead.user_id, formDataObj);
    alert("Project Head updated");
    window.location.reload();

  } else {
    await addProjectHead(formDataObj);
    alert("Project Head created");
    window.location.reload();

  }

  resetForm();
  };



  const resetForm = () => {
    setFormData({ name: '', mobile: '', email: '', projectId: '' });
    setEditingHead(null);
    setIsFormOpen(false);
  };

  const handleEdit1 = (head) => {
    const project = projects.find(
      (p) => p.project_name === head.project_name
    );

    setEditingHead(head);
    setFormData({
      name: head.ph_name,
      mobile: head.mobile,
      email: head.email,
      projectId: project ? project.id : "",
    });
    setIsFormOpen(true);
  };


  const handleEdit = (head) => {
  setEditingHead(head);

  setFormData({
    name: head.full_name || "",
    mobile: head.mobile_number || "",
    email: head.email || "",
    projectId: head.project_id ? String(head.project_id) : ""
  });

  setIsFormOpen(true);
};


  const handleDelete1 = (id) => {
    if (window.confirm('Are you sure you want to delete this project head?')) {
      deleteProjectHead(id);
      alert('Project Head deleted successfully');
    }
  };

  const handleDelete = (ph_code) => {
    if (window.confirm("Delete project head?")) {
      deleteProjectHead(ph_code);
    }
  };

  console.log('this is projectHeads',projectHeads)

  const filteredHeads = projectHeads.filter(
    (head) =>
    (head.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      head.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      head.mobile_number?.includes(searchTerm))
  );


  const getProjectNamee = (projectId) => {
    console.log('this is projectId', projectId)
    console.log('this is projects', projects)
    const id = Number(projectId); // convert string to number
    const project = projects.find((p) => p.id === id);
    return project ? project.project_name : projectId;
  };



  return (
    <div style={{ padding: 24, backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 28, fontWeight: 'bold', color: '#0B1C3D', marginBottom: 4 }}>
          Property Head Master
        </h1>
        <p style={{ color: '#666' }}>Manage project heads and their assignments</p>
      </div>

      {/* Actions Bar */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, gap: 12 }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 400 }}>
          <Search size={20} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
          <input
            type="text"
            placeholder="Search project heads..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px 8px 36px',
              border: '1px solid #ccc',
              borderRadius: 6,
              outline: 'none',
              fontSize: 14,
            }}
          />
        </div>
        <button
          onClick={() => setIsFormOpen(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            backgroundColor: '#8b306d',
            color: '#fff',
            padding: '8px 16px',
            borderRadius: 6,
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <Plus size={18} />
          Add Project Head
        </button>
      </div>

      {/* Creation Form */}

      {isFormOpen && (
        <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 16, marginBottom: 24 }}>
          <h2 style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 16, color: '#8b306d' }}>
            {editingHead ? 'Edit Project Head' : 'Create New Project Head'}
          </h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Property Allocation *</label>
                <select
                  value={formData.projectId}
                  onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                >
                  <option value="">Select Property</option>
                  {projects.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.title} - {project.location}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, textAlign: 'left', fontSize: 14, fontWeight: 500, color: '#333' }}>Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="John Doe"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333', textAlign: 'left' }}>Mobile *</label>
                <input
                  type="tel"
                  value={formData.mobile}
                  onChange={(e) =>
                    setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })
                  }
                  placeholder="6309824545"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="john@example.com"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                />
              </div>

            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button
                type="submit"
                style={{
                  backgroundColor: '#8b306d',
                  color: '#fff',
                  padding: '8px 16px',
                  borderRadius: 6,
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                {editingHead ? 'Update Project Head' : 'Create Project Head'}
              </button>
              <button
                type="button"
                onClick={resetForm}
                style={{
                  backgroundColor: '#ccc',
                  color: '#333',
                  padding: '8px 16px',
                  borderRadius: 6,
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Project Heads Table */}
      <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 8, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#8b306d', color: '#fff' }}>
            <tr>
              <th style={{ textAlign: 'center', padding: 12 }}>Name</th>
              <th style={{ textAlign: 'center', padding: 12 }}>Mobile</th>
              <th style={{ textAlign: 'center', padding: 12 }}>Email</th>
              <th style={{ textAlign: 'center', padding: 12 }}>Project Assigned</th>
              <th style={{ textAlign: 'center', padding: 12 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredHeads.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 16, textAlign: 'center', color: '#666' }}>
                  {searchTerm
                    ? 'No project heads found matching your search'
                    : 'No project heads created yet. Click "Add Project Head" to get started.'}
                </td>
              </tr>
            ) : (
              filteredHeads.map((head, index) => (
                <tr
                  key={head.id}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#f5f5f5',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0f0ff')}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#f5f5f5')
                  }
                >
                  <td style={{ padding: 12, fontWeight: 500 }}>{head.full_name}</td>
                  <td

                  >
                    <Phone size={16} style={{ color: '#999' }} />
                    {head.mobile_number}
                  </td>

                  <td

                  >
                    <Mail size={16} style={{ color: '#999' }} />
                    {head.email}
                  </td>

                  <td style={{ padding: 12 }}>
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '4px 8px',
                        borderRadius: 12,
                        backgroundColor: '#42987e',
                        color: '#fff',
                        fontSize: 12,
                      }}
                    >
                      {getProjectName(head.project_id)}
                    </span>
                  </td>
                  <td style={{ padding: 12, textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
                    <button
                      onClick={() => handleEdit(head)}
                      style={{ padding: 6, borderRadius: 6, border: 'none', cursor: 'pointer', color: '#8b306d', backgroundColor: '#e7f1ff' }}
                      title="Edit"
                    >
                      <Pencil size={16} />
                    </button>
                    <button
                      onClick={() => handleDelete(head.user_id)}
                      style={{ padding: 6, borderRadius: 6, border: 'none', cursor: 'pointer', color: '#42987e', backgroundColor: '#fdecea' }}
                      title="Delete"
                    >
                      <Trash size={16} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Stats */}
      <div style={{ marginTop: 12, fontSize: 14, color: '#666', textAlign: 'right' }}>
        Total Project Heads: {filteredHeads.length}
        {searchTerm && ` (filtered from ${projectHeads.length})`}
      </div>
    </div>
  );
};

export default ProjectHeadMaster;
